export const ACCOUNT_CACHE_KEY = 'accountDataCache_7a57b0f8';
export const PROJECTS_CACHE_KEY = 'projectsDataCache_7a57b0f8';

export function GetAccountDefaults() {
	return {
		sidebar: {
			width: 255,
			resizableButton: true,
		},
		navbar: {},
	};
}

export function UpdateAccountProperty(id, path, value) {
	const data = GetData(id, ACCOUNT_CACHE_KEY, GetAccountDefaults());
	const updatedData = SetObjectPropertyValueRecursively(data, path.split('.'), value);
	SetData(id, updatedData, ACCOUNT_CACHE_KEY);
}

export function GetAccountProperty(id, path, def) {
	const accountData = GetData(id, ACCOUNT_CACHE_KEY);

	if (accountData === undefined) {
		return def;
	}

	const propValue = GetObjectProperty(accountData, path.split('.'));

	return propValue === undefined ? def : propValue;
}

export function GetProjectDefaults() {
	return {
		assignPeopleAfterCreating: false,
		contentItemsFiltersState: {
			extendedFiltersOpened: false,
			filtersValues: {
				searchTitle: '',
				assignment: 'all',
				onlyAssignedToMe: false,
				showCompleted: true,
				assignedUsersIds: [],
				statusesIds: [],
				categoriesIds: [],
				templatesIds: [],
				page: 1,
				sortColumn: '',
				sortOrder: '',
				dueDateRangeStart: '',
				dueDateRangeEnd: '',
			}
		}
	};
}

function GetData(id, cacheKey, def) {
	const cacheString = localStorage.getItem(cacheKey);

	if (null === cacheString) {
		return def;
	}

	const cache = JSON.parse(cacheString);

	return cache[id] !== undefined
		? cache[id]
		: def
}

function SetData(id, data, cacheKey) {
	const cacheString = localStorage.getItem(cacheKey);

	if (null === cacheString) {
		localStorage.setItem(
			cacheKey,
			JSON.stringify({ [id]: data })
		);
		return;
	}

	const cache = JSON.parse(cacheString);

	cache[id] = data;

	localStorage.setItem(
		cacheKey,
		JSON.stringify(cache)
	);
}

export function UpdateProjectProperty(projectId, path, value) {
	const data = GetData(projectId, PROJECTS_CACHE_KEY, GetProjectDefaults());
	const updatedData = SetObjectPropertyValueRecursively(data, path.split('.'), value);
	SetData(projectId, updatedData, PROJECTS_CACHE_KEY);
}

export function GetProjectProperty(projectId, path, def) {
	const projectData = GetData(projectId, PROJECTS_CACHE_KEY);

	if (projectData === undefined) {
		return def;
	}

	const propValue = GetObjectProperty(projectData, path.split('.'));

	return propValue === undefined ? def : propValue;
}

export function SetObjectPropertyValueRecursively(o, props, v) {
	const pn = props.shift();
	const obj = o[pn] === undefined ? {} : o[pn];

	o[pn] = props.length
		? SetObjectPropertyValueRecursively(obj, props, v)
		: v;

	return o;
}

export function GetObjectProperty(obj, pathParts) {
	const propName = pathParts.shift();

	if (obj[propName] === undefined) {
		return undefined;
	}

	return pathParts.length
		? GetObjectProperty(obj[propName], pathParts)
		: obj[propName];
}
